import _pick from 'lodash/pick';
import { connect } from 'react-redux';
import Activity from '../components/Research/Activity';
import {
  chooseAnswer,
  finishExercise,
  retakeExercise,
} from '../actions/grades';
import { savePreference } from '../actions/preferences';
import {
  PANE_QUIZ_ORIENTATION,
  PANE_QUIZ_SIZE,
  PANE_WORKSHEET_ORIENTATION,
  PANE_WORKSHEET_SIZE,
} from '../constants/preferences';

const mapStateToProps = (state) => {
  const exercise = state.research.exercises.find(
    (item) => item.code === state.research.selectedPage
  );
  let questions = [];
  let name = '';

  // find all questions for this exercise
  if (exercise) {
    questions = state.research.questions.filter(
      (item) => item.exerciseCode === exercise.code
    );
    name = exercise.name;
  }

  // find the grade for this exercise
  const grade = state.grades.gradebook.find(
    (g) => g.exerciseCode === exercise.code
  );

  // find all responses for any of these questions
  const questionIds = questions.map((q) => q.id);
  const responses = state.grades.responses.filter(
    (r) => questionIds.indexOf(r.questionId) > -1
  );

  // find layout preferences
  /*
  const prefs = _pick(state.preferences, [
    PANE_WORKSHEET_SIZE,
    PANE_WORKSHEET_ORIENTATION,
    PANE_QUIZ_SIZE,
    PANE_QUIZ_ORIENTATION
  ]);
  */

  const prefs = {
    worksheet: {
      size: state.preferences.PANE_WORKSHEET_SIZE,
      orientation: state.preferences.PANE_WORKSHEET_ORIENTATION,
    },
    quiz: {
      size: state.preferences.PANE_QUIZ_SIZE,
      orientation: state.preferences.PANE_QUIZ_ORIENTATION,
    },
  };

  return {
    category: exercise.category,

    code: state.research.selectedPage,
    name,
    prefs,

    questions,
    responses,

    grade,
    gameMode: state.app.gameMode,

    showQuizSummary: state.app.showQuizSummary,
  };
};

const mapDispatchToProps = {
  chooseAnswer,
  finishExercise,
  savePreference,
  retakeExercise,
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
